import { render, staticRenderFns } from "./SIKBValidationSelector.vue?vue&type=template&id=76457222&scoped=true"
import script from "./SIKBValidationSelector.vue?vue&type=script&lang=js"
export * from "./SIKBValidationSelector.vue?vue&type=script&lang=js"
import style0 from "./SIKBValidationSelector.vue?vue&type=style&index=0&id=76457222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76457222",
  null
  
)

export default component.exports